import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-20 bg-brand-primary text-white text-center" data-id="element-49">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-51">
          <span className="inline-block bg-orange-500 text-white text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-6" data-id="element-52">
            Última oportunidad
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-53">
            Tu hígado puede recuperarse.{' '}
            <span className="text-orange-500" data-id="element-54">Tú tienes el poder.</span>
          </h2>
          <p className="text-xl text-brand-bg/80 mb-10 max-w-2xl mx-auto" data-id="element-55">
            No esperes a que el médico te dé malas noticias. Empieza hoy con
            recetas deliciosas, prácticas y diseñadas para apoyar el bienestar
            de tu hígado desde adentro.
          </p>

          <div className="flex flex-col items-center justify-center gap-6" data-id="element-56">
            <div className="text-4xl font-extrabold text-brand-accent" data-id="element-57">
              Solo $16{' '}
              <span className="text-lg text-gray-400 line-through font-normal ml-2" data-id="element-58">
                $64
              </span>
            </div>

            <a href="https://noveliahub.com/cart/50878318477348:1" className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white text-xl font-bold py-5 px-10 rounded-full shadow-[0_8px_30px_rgba(249,115,22,0.5)] transition-transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-orange-400/60 animate-pulse" data-id="element-59">
              Sí, quiero apoyar el bienestar de mi hígado
            </a>

            <p className="text-sm text-brand-bg/60" data-id="element-60">
              Acceso inmediato • Pago seguro • Garantía de 60 días
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}